import { render, staticRenderFns } from "./BenefitSubscriptionFormFields.vue?vue&type=template&id=195a0568&scoped=true"
import script from "./BenefitSubscriptionFormFields.vue?vue&type=script&lang=js"
export * from "./BenefitSubscriptionFormFields.vue?vue&type=script&lang=js"
import style0 from "./BenefitSubscriptionFormFields.vue?vue&type=style&index=0&id=195a0568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a0568",
  null
  
)

export default component.exports